export default "__VITE_ASSET__Dr2kT5ow__"